import { tokens } from 'src/design-system';
import { commonStyles } from 'src/Library/CommonStyles';

export const SEQuoteCardStyles = (theme) => ({
  cardDiv: {
    width: '100%',
    marginBottom: tokens.spacing.ms,
    border: `1px solid ${tokens.colors.border}`,
    borderRadius: tokens.radius.lg,
    backgroundColor: tokens.colors.bgWhite,
    overflow: 'hidden',
    transition: tokens.transition.fast,
  },
  // Hover affordance only for a selectable card — never on the submitted / approval (read-only) view.
  interactive: {
    '&:hover': {
      borderColor: tokens.colors.primary,
      boxShadow: tokens.shadow.sm,
    },
  },
  // Accent the card the operator has actually chosen (radio selected) so the pick is obvious at a glance.
  cardSelected: {
    borderColor: tokens.colors.primary,
    boxShadow: `0 0 0 1px ${tokens.colors.primary}`,
  },
  cardBody: {
    padding: `${tokens.spacing.md}px ${tokens.spacing.ms}px`,
    display: 'flex',
    alignItems: 'center',
  },
  cardBodyColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    rowGap: tokens.spacing.xs,
    padding: `0 ${tokens.spacing.md}px`,
  },
  columnBorderLeft: {
    borderLeft: `1px solid ${tokens.colors.border}`,
  },
  orgName: {
    fontSize: tokens.fontSize.h3,
    color: tokens.colors.text,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: 1.3,
    ...commonStyles(theme).ellipses,
  },
  label: {
    fontSize: tokens.fontSize.caption,
    color: tokens.colors.textTertiary,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    lineHeight: 1.4,
  },
  value: {
    fontSize: tokens.fontSize.body,
    color: tokens.colors.textSecondary,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: 1.4,
  },
  boldPrice: {
    fontSize: tokens.fontSize.h1,
    color: tokens.colors.primaryDark,
    fontWeight: tokens.fontWeight.bold,
    lineHeight: 1.3,
  },
  deviation: {
    display: 'inline-block',
    marginTop: tokens.spacing.xs,
    fontSize: tokens.fontSize.caption,
    color: tokens.colors.error,
    lineHeight: 1.4,
  },
  referenceCard: {
    opacity: 0.7,
  },
  bottomDiv: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacing.sm,
    backgroundColor: tokens.colors.bgSubtle,
    borderTop: `1px solid ${tokens.colors.border}`,
    padding: `${tokens.spacing.sm}px ${tokens.spacing.md}px`,
  },
  // Rank pill — L1 gets the success colour, the rest a neutral chip.
  rankBadge: {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacing.xxs,
    padding: `${tokens.spacing.xxs}px ${tokens.spacing.sm}px`,
    borderRadius: tokens.radius.pill,
    fontSize: tokens.fontSize.caption,
    fontWeight: tokens.fontWeight.bold,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  rankBadgeTop: {
    background: tokens.colors.success,
    color: tokens.colors.bgWhite,
  },
  rankBadgeOther: {
    background: tokens.colors.border,
    color: tokens.colors.textSecondary,
  },
  // NOTE: flex `gap` is intentionally avoided throughout this card — this react-jss build drops it, which is
  // what made "For reference only" collide with "View Details". Child margins are used instead.
  subFieldWrap: {
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',
    paddingLeft: tokens.spacing.sm,
  },
  subFieldChip: {
    fontSize: tokens.fontSize.caption,
    color: tokens.colors.textSecondary,
    background: tokens.colors.bgWhite,
    border: `1px solid ${tokens.colors.border}`,
    borderRadius: tokens.radius.sm,
    padding: `${tokens.spacing.xxs}px ${tokens.spacing.sm}px`,
    marginRight: tokens.spacing.xs,
    marginBottom: tokens.spacing.xxs,
  },
  subFieldLabel: {
    color: tokens.colors.textTertiary,
  },
  bottomActions: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    // Wrap onto a second line on very narrow cards instead of overlapping.
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    paddingLeft: tokens.spacing.sm,
  },
  viewDetails: {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    color: tokens.colors.primaryDark,
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.small,
    cursor: 'pointer',
    '&:hover': { textDecoration: 'underline' },
    // Space the arrow icon from the label (was a dropped flex `gap`).
    '& .anticon': { marginLeft: tokens.spacing.xxs },
  },
  referenceNote: {
    color: tokens.colors.textTertiary,
    fontSize: tokens.fontSize.caption,
    fontStyle: 'italic',
    whiteSpace: 'nowrap',
    // Guaranteed separation from the View Details action (this build drops flex `gap`).
    marginRight: tokens.spacing.ms,
  },
});
